import * as React from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogActions from "@material-ui/core/DialogActions";
import { updateDelivery } from "../../../../../sdk/release";
import { ReleaseStore } from "../../../../../../../../common/types/release/release-store";
import { Button } from "@material-ui/core";

interface UpdateReleaseDelivery {
  releaseId: string; 
  instruction: 'redeliver' | 'takedown';
  stores: ReleaseStore[];
  isOpen: boolean;
  setOpen: (state: boolean) => void;
}

export const UpdateStoreDelivery: React.FC<UpdateReleaseDelivery> = (props) => {
  const {releaseId, instruction, stores, isOpen, setOpen} = props;
  const [loading, setLoading] = React.useState(false);

  const handleDelivery = async () => {
    setLoading(true);
    updateDelivery(releaseId, instruction, stores).then(() => {
      window.location.reload();
    });
    setLoading(false);
    setOpen(false);
  };

  return (
    <Dialog open={isOpen} onClose={() => setOpen(false)} aria-labelledby="form-dialog-title">
      <DialogTitle id="form-dialog-title">
        {instruction === 'redeliver'? "Deliver Release To": "Takedown Release From"}
      </DialogTitle>
      <DialogContent>
          <DialogContentText>
            {stores.map((s) => s.name).join(',')}
          </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setOpen(false)} color="primary">
          Cancel
        </Button>
        <Button disabled={loading} onClick={() => handleDelivery()} color="default">
          Send
        </Button>
      </DialogActions>
    </Dialog>
  );
};
